import type { StaffRole } from '@ucp/web/lib';

/**
 * Every role that holds a `policy_*` capability (server `capabilities.ts` map). Mirrors
 * the server role→capability map; `L6_PLATFORM_ADMIN` is DELIBERATELY absent (ADR-018
 * EoP — never a Policies shortcut). Extracted into this dependency-light module so the
 * `AppRoutes` route guard + `modulesConfig` gate can import it without pulling the
 * lazy-loaded `PoliciesSurface` into the initial bundle (mirrors `peopleAssistantRoles`).
 */
export const POLICY_ROLES: readonly StaffRole[] = ['POLICY_OWNER', 'POLICY_APPROVER'];
